<template>
    <div>
        <AlertDismiss ref="alertDismiss"></AlertDismiss>

        <b-pagination v-model="filter.page" :total-rows="rows" :per-page="filter.pageSize"
            aria-controls="table-list-users" class="m-2" pills>
        </b-pagination>
    </div>
</template>
<script>
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'

export default {
    name: 'EvaluationAttemptsPagination',

    data() {
        return {
            filter: {
                page: 1,
                pageSize: InitPageSize.EvaluationAttemptsPageSize
            },

            rows: 0
        }
    },

    components: {
        AlertDismiss
    },

    async mounted() {
        await this.getCount();

        await this.paginationFilter();
    },

    methods: {
        ...mapActions(["countEvaluationAttempts"]),

        paginationFilter() {
            this.$eventBus.$emit(EventNames.EvaluationPaginationFilter, this.filter);
        },

        async getCount() {
            let result = await this.countEvaluationAttempts();
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            this.rows = result.data;
        }
    },

    watch: {
        async "filter.page"() {
            this.paginationFilter();
        },
    },

    
}
</script>
